export { Tag } from './tag/tag'
export { TagAutonomousBooking } from './tag-autonomous-booking/TagAutonomousBooking'
export { TagAvailableSoon } from './tag-available-soon/TagAvailableSoon'
export { TagCheckinCheckout } from './tag-checkin-checkout/TagCheckinCheckout'
